import { createContext, useContext } from "react";
const initialState = {
  getCountryAddressForm: () => void 0,
  addressTemplates: void 0
};
const AddressFormsContext = createContext(initialState);
const getAddressForm = (templates, country) => {
  return templates?.find((template) => template.country === country)?.template || templates?.find((template) => template.country === "COMMON")?.template;
};
function useAddressForms() {
  const context = useContext(AddressFormsContext);
  if (context === void 0) {
    throw new Error(
      "useAddressForms must be used within a AddressFormsContext"
    );
  }
  return context;
}
export {
  AddressFormsContext,
  getAddressForm,
  useAddressForms
};
//# sourceMappingURL=address-forms-context.js.map
